import {
    WebGLRenderer,
    ACESFilmicToneMapping,
    sRGBEncoding,
    Scene,
    PerspectiveCamera,
    Raycaster,
    Vector2,
    Box3,
    Vector3
} from 'three/build/three.min';

import {
    OrbitControls
} from 'three/examples/jsm/controls/OrbitControls'

import TWEEN from '@tweenjs/tween.js';

import * as P from './postProcessing';

import initRGBE from './rgbeLoader';

import initGLTF from './gltfLoader';

export const v = {};

v.init = async (canvas, hdr, gltf) => {
        v.renderer = new WebGLRenderer({
            canvas: canvas,
            alpha: true,
            antialias: true,
        });
        v.renderer.toneMapping = ACESFilmicToneMapping;
        v.renderer.toneMappingExposure = 4;
        v.renderer.outputEncoding = sRGBEncoding;
        v.renderRequested = false;

        v.scene = new Scene();

        v.camera = new PerspectiveCamera(75, 2, 0.1, 50);
        v.camera.position.set(7.8, 8.4, 6.7);

        v.controls = new OrbitControls(v.camera, canvas);
        v.controls.update();

        v.canvas = canvas

        P.init(v.renderer, v.scene, v.camera);

        await initRGBE(v.renderer, v.scene, hdr)

        const res = await initGLTF(v.scene, gltf);

        v.objects = res.objects;
        v.root = res.rootObjects;
        console.log(v.root);

        v.requestRenderIfNotRequested();

        v.controlTimeout;
        v.controlsChange = false;

        window.addEventListener('resize', v.requestRenderIfNotRequested);
        v.controls.addEventListener('change', v.onControlsChange);

        console.log('initialized');

        v.intersected

    },
    v.onControlsChange = () => {
        
        v.hideOutlines();
        v.intersected = null
        v.requestRenderIfNotRequested();
        
        window.clearTimeout( v.controlTimeout );
        v.controlsChange = true;

        v.controlTimeout = setTimeout(() => {
            v.controlsChange = false;
        }, 150);
        
    },
    v.resizeRendererToDisplaySize = (renderer) => {
        const canvas = renderer.domElement;
        const pixelRatio = window.devicePixelRatio;
        const width  = canvas.clientWidth  * pixelRatio | 0;
        const height = canvas.clientHeight * pixelRatio | 0;
        const needResize = canvas.width !== width || canvas.height !== height;
        if (needResize) {
            renderer.setSize(width, height, false);
            P.resizeComposer(width, height)
            P.resizeFxaa(width);
        }
        return needResize;
    },
    v.render = () => {
        v.renderRequested = false;
        if (v.resizeRendererToDisplaySize(v.renderer)) {
            const canvas = v.renderer.domElement;
            v.camera.aspect = canvas.clientWidth / canvas.clientHeight;
            v.camera.updateProjectionMatrix();
        }
        v.controls.update();
        P.renderComposer(v.scene, v.camera)
    },
    v.requestRenderIfNotRequested = () => {
        if (!v.renderRequested) {
            v.renderRequested = true;
            requestAnimationFrame(v.render)
        }
    },
    v.isVisible = (object) => {
        if (object.layers.mask === 1) {
            return true
        } else {
            return false;
        }
    },
    v.showObject = (object) => {
        object.layers.set(0);
        object.children.forEach(x => {
            x.layers.set(0);
        });
    },
    v.hideObject = (object) => {
        object.layers.set(1)
        object.children.forEach(x => {
            x.layers.set(1);
        });
    },
    v.showOutline = (object) => {
        P.showOutlines([object]);
    },
    v.showOutlines = (objects) => {
        P.showOutlines(objects);
    },
    v.hideOutlines = () => {
        P.hideOutlines();
    },
    v.createCameraTween = (cameraPos, controlsTar = {x: 0, y: 0, z:0}) => {

        let i = setInterval(() => {
            TWEEN.update();
            v.requestRenderIfNotRequested();
        }, 20)

        let currentCam = v.camera.position

        let currentTar = v.controls.target

        new TWEEN.Tween(currentCam)
            .to(cameraPos, 1500)
            .onUpdate(() => {
                v.camera.position.x = currentCam.x
                v.camera.position.y = currentCam.y
                v.camera.position.z = currentCam.z
            })
            .easing(TWEEN.Easing.Quadratic.Out)
            .onComplete(() => {
                //clearInterval(i)
            })
            .start()

        new TWEEN.Tween(currentTar)
            .to(controlsTar, 1800)
            .onUpdate(() => {
                v.controls.target.x = currentTar.x
                v.controls.target.y = currentTar.y
                v.controls.target.z = currentTar.z
            })
            .easing(TWEEN.Easing.Quadratic.Out)
            .onComplete(() => {
                clearInterval(i)
            })
            .start()
    },
    v.createOutlineRaycaster = (objects) => {
        v.isMouseDown = false;
        v.raycaster = new Raycaster();
        v.mouse = new Vector2();
        let doClickOnRelease = false;
        let intersects, absoluteOffsetLeft = 0, absoluteOffsetTop = 0;

        let obj = v.canvas;

        if (obj.offsetParent) {
            do {
              absoluteOffsetLeft += obj.offsetLeft;
              absoluteOffsetTop += obj.offsetTop;
            } while (obj = obj.offsetParent);
          } else {
            console.log("Method offsetParent not supported");
          }

        function mouseMove(e) {
            e.preventDefault();

            doClickOnRelease = false;
            
            if(!v.controlsChange && !v.isMouseDown) {
                intersects = v.raycaster.intersectObjects(objects);

                v.mouse.x = ((e.clientX - absoluteOffsetLeft) / canvas.clientWidth) * 2 - 1;
                v.mouse.y = -((e.clientY - absoluteOffsetTop) / canvas.clientHeight) * 2 + 1;
    
                v.raycaster.setFromCamera(v.mouse, v.camera);
    
                if(intersects.length > 0) {

                    if(v.intersected != intersects[0].object) {

                        v.intersected = intersects[0].object;

                        if(v.intersected.parent.name != 'Scene') {
                            v.showOutline(v.intersected.parent);
                        } else {
                            v.showOutline(v.intersected);
                        }
                        v.requestRenderIfNotRequested();
                    }
                    
                    
                    v.canvas.style.cursor = 'pointer';

                } else {
                    v.intersected = null;
                    v.canvas.style.cursor = 'grab';
                    v.hideOutlines();
                    v.requestRenderIfNotRequested();
                }
            }
        }

        function mouseDown(e) {
            v.isMouseDown = true;
            doClickOnRelease = true
            v.canvas.style.cursor = 'grabbing';
        }

        function mouseUp(e) {
            v.isMouseDown = false;
            v.canvas.style.cursor = 'grab';
            if(doClickOnRelease && v.intersected != null) {
                if(v.intersected.parent.name != 'Scene') {
                    v.canvas.dispatchEvent(new CustomEvent('clickedObj', { detail: { obj: v.intersected.parent } }));
                } else {
                    v.canvas.dispatchEvent(new CustomEvent('clickedObj', { detail: { obj: v.intersected } }));
                }
            }
        }

        function mouseLeave(e) {
            v.hideOutlines();
            v.requestRenderIfNotRequested();
            v.intersected = null;
        }

        v.canvas.addEventListener('mousedown', mouseDown);
        v.canvas.addEventListener('mouseup', mouseUp);
        v.canvas.addEventListener('mouseleave', mouseLeave);
        v.canvas.addEventListener('mousemove', mouseMove);
    },
    v.focusObject = (pos, obj) => {
        //const center = v.getCenter(obj);
        v.createCameraTween(pos, obj);
    },
    v.getCenter = (obj) => {
        const box = new Box3().setFromObject(obj);
        const boxCenter = box.getCenter(new Vector3());
        return boxCenter;
    }